import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { useMemo } from 'react';
import { convertFieldValueAvroToJson } from 'rpc-client-utils';
import { useGetTicketDetailsQuery } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.hooks';
import { GET_TICKET_DETAILS_QUERY_FIELD_NAME } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.dfc.new';
export { GET_TICKET_DETAILS_QUERY } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.dfc.new';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { getIsPreview } from '../utils/isPreview';
import { getPreviewTicket } from './previewMocks';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
export const GET_TICKET_KEY = GET_TICKET_DETAILS_QUERY_FIELD_NAME;
export const useTicket = id => {
  const {
    isPreview
  } = getIsPreview();
  const _useGetTicketDetailsQ = useGetTicketDetailsQuery({
      variables: {
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId(),
        params: {
          ticketId: id
        }
      },
      skip: !id || isPreview
    }),
    {
      data,
      loading,
      refetch
    } = _useGetTicketDetailsQ,
    rest = _objectWithoutPropertiesLoose(_useGetTicketDetailsQ, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  const ticket = useMemo(() => {
    if (isPreview && id) {
      return getPreviewTicket(id);
    }
    if (!data) {
      return undefined;
    }
    const decodedTicket = {};
    for (const [key, value] of Object.entries(data.properties)) {
      decodedTicket[key] = convertFieldValueAvroToJson(value);
    }
    return decodedTicket;
  }, [isPreview, id, data]);
  return Object.assign({
    data: ticket,
    refetch,
    loading
  }, rest);
};